// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fancy-login-popup-area {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7); 
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    -webkit-backdrop-filter: blur(8px);
            backdrop-filter: blur(8px); 
  }
  
  .fancy-login-popup {
    background: var(--clr-grey-10);
    padding: 2.5rem; 
    border-radius: var(--radius);
    box-shadow: var(--dark-shadow);
    max-width: 500px;
    width: 100%;
    position: relative;
    animation: fadeIn 0.5s ease-in-out; 
  }
  
  .fancy-close-popup {
    position: absolute;
    top: 1.2rem; 
    right: 1.2rem;
    cursor: pointer;
    font-size: 1.8rem; 
    color: var(--clr-primary-5); 
    transition: color 0.3s ease-in-out;
  }
  
  .fancy-close-popup:hover {
    color: var(--clr-primary-7);
  }
  
  .fancy-toggle-container {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem; 
  }
  
  .fancy-toggle-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 1rem; 
    font-weight: bold;
    color: var(--clr-primary-5);
  }
  
  .fancy-toggle-input {
    display: none;
  }
  
  .fancy-toggle-slider {
    width: 50px; 
    height: 24px;
    background: var(--clr-grey-4);
    border-radius: 24px; 
    position: relative;
    margin-right: 0.75rem; 
    transition: background 0.3s ease-in-out;
  }
  
  .fancy-toggle-slider::before {
    content: '';
    position: absolute;
    width: 22px; 
    height: 22px;
    background: var(--clr-white);
    border-radius: 50%;
    top: 1px;
    left: 1px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); 
    transition: transform 0.3s ease-in-out;
  }
  
  .fancy-toggle-input:checked + .fancy-toggle-slider {
    background: var(--clr-primary-5);
  }
  
  .fancy-toggle-input:checked + .fancy-toggle-slider::before {
    transform: translateX(26px); 
  }
  
  .fancy-toggle-text {
    font-size: 1rem;
  }
  
  .fancy-cfield {
    position: relative;
    margin-bottom: 2rem; 
  }
  
  .fancy-cfield input {
    width: 100%;
    padding: 1rem 2.5rem; 
    border-radius: var(--radius);
    border: 1px solid var(--clr-grey-7);
    font-size: 1rem;
    background: var(--clr-grey-10);
    transition: border 0.3s ease-in-out;
  }
  
  .fancy-cfield input:focus {
    border-color: var(--clr-primary-5);
    outline: none;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); 
  }
  
  .fancy-cfield i {
    position: absolute;
    left: 1rem; 
    top: 50%;
    transform: translateY(-50%);
    color: var(--clr-primary-5);
    font-size: 1.5rem; 
  }
  
  .fancy-error-msg {
    color: var(--clr-primary-5);
    margin-bottom: 1.5rem;
    text-align: center;
    font-size: 0.9rem;
    background-color: var(--clr-primary-9);
    padding: 0.5rem;
    border-radius: var(--radius);
  }
  
  .fancy-btn {
    background: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    padding: 1rem; 
    border-radius: var(--radius);
    cursor: pointer;
    width: 100%;
    font-size: 1.1rem; 
    font-weight: bold;
    transition: var(--transition);
  }
  
  .fancy-btn:hover {
    background: var(--clr-primary-6);
  }
  
  .fancy-btn-request-otp {
    background: var(--clr-primary-7);
    color: var(--clr-white);
    padding: 0.5rem;
    width: 100%;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    font-size: 0.9rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  
  /* Hover state */
  .fancy-btn-request-otp:hover {
    background: var(--clr-primary-8);
  }
  
  /* Disabled state styles */
  .fancy-btn-request-otp:disabled {
    background: var(--clr-primary-3); /* Lighter color to indicate disabled state */
    color: var(--clr-gray); /* Gray color for text to indicate it's not active */
    cursor: not-allowed; /* Show "not-allowed" cursor */
    opacity: 0.6; /* Add opacity for a more subdued look */
  }
  

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .phone-input-split {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .phone-prefix-login {
    background-color: #f5f5f5;
    border: 1px solid #ccc;
    padding: 0.5rem 0.75rem;
    border-radius: 4px;
    font-weight: 500;
    color: #333;
    min-width: 50px;
    text-align: center;
  }
  
  .phone-input-wrapper {
    position: relative;
    flex: 1 1;
  }
  
  .phone-input-wrapper input {
    width: 100%;
    padding-right: 2rem;
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/account/Login.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kCAA0B;YAA1B,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;IAC9B,eAAe;IACf,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,4BAA4B;IAC5B,mCAAmC;IACnC,eAAe;IACf,8BAA8B;IAC9B,mCAAmC;EACrC;;EAEA;IACE,kCAAkC;IAClC,aAAa;IACb,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,gCAAgC;IAChC,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,gCAAgC;IAChC,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,uCAAuC;IACvC,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,gBAAgB;EAChB;IACE,gCAAgC;EAClC;;EAEA,0BAA0B;EAC1B;IACE,gCAAgC,EAAE,6CAA6C;IAC/E,sBAAsB,EAAE,oDAAoD;IAC5E,mBAAmB,EAAE,8BAA8B;IACnD,YAAY,EAAE,wCAAwC;EACxD;;;EAGA;IACE;MACE,UAAU;MACV,4BAA4B;IAC9B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAO;EACT;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB","sourcesContent":[".fancy-login-popup-area {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7); \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    backdrop-filter: blur(8px); \n  }\n  \n  .fancy-login-popup {\n    background: var(--clr-grey-10);\n    padding: 2.5rem; \n    border-radius: var(--radius);\n    box-shadow: var(--dark-shadow);\n    max-width: 500px;\n    width: 100%;\n    position: relative;\n    animation: fadeIn 0.5s ease-in-out; \n  }\n  \n  .fancy-close-popup {\n    position: absolute;\n    top: 1.2rem; \n    right: 1.2rem;\n    cursor: pointer;\n    font-size: 1.8rem; \n    color: var(--clr-primary-5); \n    transition: color 0.3s ease-in-out;\n  }\n  \n  .fancy-close-popup:hover {\n    color: var(--clr-primary-7);\n  }\n  \n  .fancy-toggle-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 2rem; \n  }\n  \n  .fancy-toggle-label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-size: 1rem; \n    font-weight: bold;\n    color: var(--clr-primary-5);\n  }\n  \n  .fancy-toggle-input {\n    display: none;\n  }\n  \n  .fancy-toggle-slider {\n    width: 50px; \n    height: 24px;\n    background: var(--clr-grey-4);\n    border-radius: 24px; \n    position: relative;\n    margin-right: 0.75rem; \n    transition: background 0.3s ease-in-out;\n  }\n  \n  .fancy-toggle-slider::before {\n    content: '';\n    position: absolute;\n    width: 22px; \n    height: 22px;\n    background: var(--clr-white);\n    border-radius: 50%;\n    top: 1px;\n    left: 1px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); \n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .fancy-toggle-input:checked + .fancy-toggle-slider {\n    background: var(--clr-primary-5);\n  }\n  \n  .fancy-toggle-input:checked + .fancy-toggle-slider::before {\n    transform: translateX(26px); \n  }\n  \n  .fancy-toggle-text {\n    font-size: 1rem;\n  }\n  \n  .fancy-cfield {\n    position: relative;\n    margin-bottom: 2rem; \n  }\n  \n  .fancy-cfield input {\n    width: 100%;\n    padding: 1rem 2.5rem; \n    border-radius: var(--radius);\n    border: 1px solid var(--clr-grey-7);\n    font-size: 1rem;\n    background: var(--clr-grey-10);\n    transition: border 0.3s ease-in-out;\n  }\n  \n  .fancy-cfield input:focus {\n    border-color: var(--clr-primary-5);\n    outline: none;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); \n  }\n  \n  .fancy-cfield i {\n    position: absolute;\n    left: 1rem; \n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--clr-primary-5);\n    font-size: 1.5rem; \n  }\n  \n  .fancy-error-msg {\n    color: var(--clr-primary-5);\n    margin-bottom: 1.5rem;\n    text-align: center;\n    font-size: 0.9rem;\n    background-color: var(--clr-primary-9);\n    padding: 0.5rem;\n    border-radius: var(--radius);\n  }\n  \n  .fancy-btn {\n    background: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    padding: 1rem; \n    border-radius: var(--radius);\n    cursor: pointer;\n    width: 100%;\n    font-size: 1.1rem; \n    font-weight: bold;\n    transition: var(--transition);\n  }\n  \n  .fancy-btn:hover {\n    background: var(--clr-primary-6);\n  }\n  \n  .fancy-btn-request-otp {\n    background: var(--clr-primary-7);\n    color: var(--clr-white);\n    padding: 0.5rem;\n    width: 100%;\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: background 0.3s ease-in-out;\n    font-size: 0.9rem;\n    margin-bottom: 1rem;\n    text-align: center;\n  }\n  \n  /* Hover state */\n  .fancy-btn-request-otp:hover {\n    background: var(--clr-primary-8);\n  }\n  \n  /* Disabled state styles */\n  .fancy-btn-request-otp:disabled {\n    background: var(--clr-primary-3); /* Lighter color to indicate disabled state */\n    color: var(--clr-gray); /* Gray color for text to indicate it's not active */\n    cursor: not-allowed; /* Show \"not-allowed\" cursor */\n    opacity: 0.6; /* Add opacity for a more subdued look */\n  }\n  \n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: translateY(-10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .phone-input-split {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  \n  .phone-prefix-login {\n    background-color: #f5f5f5;\n    border: 1px solid #ccc;\n    padding: 0.5rem 0.75rem;\n    border-radius: 4px;\n    font-weight: 500;\n    color: #333;\n    min-width: 50px;\n    text-align: center;\n  }\n  \n  .phone-input-wrapper {\n    position: relative;\n    flex: 1;\n  }\n  \n  .phone-input-wrapper input {\n    width: 100%;\n    padding-right: 2rem;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
